const _ = require('lodash')
export const countries = require('./data/countries.json')
export const subdivisions = require('./data/subdivisions.json')

export function getSubdivisionsByCountry (countryCode) {
  return _.sortBy(subdivisions[countryCode] || [], 'name')
}
